export default class Donut {
  constructor(container) {
    this.container = container;
    this.size = this.container.dataset.size;
    this.strokeWidth = this.size / 8;
    this.radius = (this.size / 2) - (this.strokeWidth / 2);
    this.value = this.container.dataset.value;
    this.svg;
    this.defs;
    this.slice;
    this.text;
    this.create();
  }

  create() {
    this.createSvg();
    this.createDefs();
    this.createSlice();
    this.createText();

    if (this.container.childNodes.length > 0) {
      this.container.removeChild(this.container.childNodes[0])
    }

    this.container.appendChild(this.svg);
  }

  createSvg() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute('width', `${this.size}px`);
    svg.setAttribute('height', `${this.size}px`);
    this.svg = svg;
  }

  createDefs() {
    const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
    const linearGradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
    linearGradient.setAttribute('id', 'gradient');
    linearGradient.setAttribute('x1', '50%');
    linearGradient.setAttribute('x2', '50%');
    linearGradient.setAttribute('y1', '-2.48949813e-15%');
    linearGradient.setAttribute('y2', '100%');
    var stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    stop1.setAttribute('stop-color', '#21D9F7');
    stop1.setAttribute('offset', '0%');
    linearGradient.appendChild(stop1);
    var stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    stop2.setAttribute('stop-color', '#5757D9');
    stop2.setAttribute('offset', '100%');
    linearGradient.appendChild(stop2);
    defs.appendChild(linearGradient);
    this.svg.appendChild(defs);
    this.defs = defs;
  }

  createSlice() {
    const slice = document.createElementNS("http://www.w3.org/2000/svg", "path");
    slice.setAttribute('fill', 'none');
    slice.setAttribute('stroke', 'url(#gradient)');
    slice.setAttribute('stroke-width', this.strokeWidth);
    slice.setAttribute('transform', `translate(${this.strokeWidth / 2},${this.strokeWidth / 2})`);
    slice.setAttribute('class', 'animate-draw');

    const background = document.createElementNS("http://www.w3.org/2000/svg", "path");
    background.setAttribute('fill', 'none');
    background.setAttribute('stroke', '#f9f9f9');
    background.setAttribute('stroke-width', this.strokeWidth);
    background.setAttribute('transform', `translate(${this.strokeWidth / 2},${this.strokeWidth / 2})`);
    background.setAttribute('class', 'animate-draw');

    this.svg.appendChild(background);
    this.svg.appendChild(slice);
    this.slice = slice;
    this.background = background;
  }

  createText() {
    const fontSize = this.size / 5;
    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute('x', (this.size / 2) + fontSize / 7.5);
    text.setAttribute('y', (this.size / 2) + fontSize / 4);
    text.setAttribute('font-family', 'Open Sans');
    text.setAttribute('font-size', fontSize);
    text.setAttribute('fill', '#2C3E50');
    text.setAttribute('text-anchor', 'middle');
    const tspanSize = fontSize / 3;
    text.innerHTML = `${0}<tspan font-size="${tspanSize}" dy="${-tspanSize * 1.2}">%</tspan>`;
    this.svg.appendChild(text);
    this.text = text;
  }

  animateStart() {
    let v = 0;
    const self = this;
    const intervalOne = setInterval(() => {
      const p = +(v / self.value).toFixed(2);
      const a = (p < 0.95) ? 2 - (2 * p) : 0.05;
      v += a;
      // Stop
      if(v >= +self.value) {
        v = self.value;
        clearInterval(intervalOne);
      }
      self.setValue(v);
    }, 5);
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }

  describeArc(x, y, radius, startAngle, endAngle) {
    const start = this.polarToCartesian(x, y, radius, endAngle);
    const end = this.polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    const d = [
      "M", start.x, start.y,
      "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ");
    return d;
  }

  setValue(value) {
    let c = (value / 100) * 360;
    if (c === 360) {
      c = 359.99;
    }
    const xy = this.size / 2 - this.strokeWidth / 2;
    const d = this.describeArc(xy, xy, xy, 180, 180 + c);
    const backgroundD = this.describeArc(xy, xy, xy, 0, 359.99);
    this.slice.setAttribute('d', d);
    this.background.setAttribute('d', backgroundD);
    const tspanSize = (this.size / 3.5) / 3;
    this.text.innerHTML = `${Math.floor(value)}<tspan font-size="${tspanSize}" dy="${-tspanSize * 1.2}">%</tspan>`;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/donut.js